import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IDialogContentComponent } from '../../modal-dialog/modal-dialog.service';

export interface GlobalNotificationInput {
  // Pas d'input spécifique nécessaire
}

export interface GlobalNotificationResult {
  message: string;
}

@Component({
  selector: 'app-global-notification-popup',
  templateUrl: './global-notification-popup.component.html',
  styleUrls: ['./global-notification-popup.component.scss']
})
export class GlobalNotificationPopupComponent implements OnInit, IDialogContentComponent<GlobalNotificationResult, GlobalNotificationInput> {
  input?: GlobalNotificationInput;
  notificationForm: FormGroup;

  constructor(private readonly formBuilder: FormBuilder) {
    this.notificationForm = this.formBuilder.group({
      message: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(255)]]
    });
  }

  ngOnInit(): void {
    // Méthode requise par l'interface
  }

  getResult(): GlobalNotificationResult {
    return {
      message: this.notificationForm.value.message
    };
  }

  isDisabled(): boolean {
    return !this.notificationForm.valid;
  }

  get messageControl() {
    return this.notificationForm.get('message');
  }

  get messageErrorText(): string {
    const control = this.messageControl;
    if (control?.hasError('required')) {
      return 'Le message est obligatoire';
    }

    if (control?.hasError('minlength')) {
      return 'Le message doit contenir au moins 10 caractères';
    }

    if (control?.hasError('maxlength')) {
      return 'Le message ne peut pas dépasser 255 caractères';
    }

    return '';
  }
}
